<template>
    <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid p-0">
            <!-- login page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-md-12">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="text-center"><img alt="" src="../assets/images/logo-dark.png" width="150"></div>
                                <div class="card mt-4">
                                    <div class="card-body">
                                        <div class="text-center text-uppercase">
                                            <h4>Forgot Your Password?</h4>
                                        </div>
                                        <form class="theme-form" @submit.prevent="handleSubmit">
                                            <div class="form-group">
                                                <label for="email" class="col-form-label">Email</label>
                                                <input type="email" v-model="user.email" id="email" name="email"
                                                       class="form-control"
                                                       :class="{ 'is-invalid': submitted && $v.user.email.$error }"/>
                                                <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                                                    <span v-if="!$v.user.email.required">Email is required</span>
                                                    <span v-if="!$v.user.email.email">Email is invalid</span>
                                                </div>
                                            </div>
                                            <div class="form-group form-row mt-3 mb-0 loading-wrapper">
                                                <div class="btn-loading" v-if="loading">
                                                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                                </div>
                                                <button class="btn btn-primary btn-block">Reset password</button>
                                            </div>
                                            <hr class="hr-text" data-content="OR">
                                            <div class="form-group form-row mt-3 mb-0 row">
                                                <router-link to="/auth/login" tag="button"
                                                     class="btn btn-secondary btn-block">Login
                                                </router-link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- login page end-->
        </div>
    </div>
    <!-- latest jquery-->
</template>

<script>
  import {required, email} from "vuelidate/lib/validators";

  export default {
    name: 'forgot-password',
    data() {
      return {
        user: {
          email: "",
          password: ""
        },
        submitted: false,
        loading: false
      }
    },
    validations: {
      user: {
        email: {required, email},
      }
    },
    methods: {
      handleSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.loading = true;

        this.$store.dispatch('passwordResetRequest', this.user.email).then(() => {
          this.$swal({
            title: "Success!",
            text: "Email Sent, please check your inbox",
            type:'success'
          });
          this.loading = false;
        }).catch((error) => {
          let text = error.response.data.responseException.exceptionMessage
          ? error.response.data.responseException.exceptionMessage
          : 'Please try again';
          this.$toasted.show( text , {
            theme: 'bubble',
            position: "bottom-right",
            type: 'error',
            duration: 4000
          });
          this.loading = false;
        });
      },
    }
  }
</script>
<style scoped>
  .page-wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
  .authentication-main .auth-innerright {
    min-height: auto;
  }
  .authentication-main {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
